export class EnaioObjectDefTranslation {
    languageId = 0;
    name = "";
    toolTip = "";
    imageId = "";
    defaultUrl = "";
    newUrl = "";
    updateUrl = "";
    requestUrl = "";
    readOnlyUrl = "";
}
